//
// File: AuthChallengeName.ts
// Description: Mapping of auth/cognito challenge name to our enum
// Copyright: Broadlume 2024
//

/**
 * Mapping of auth/cognito challenge name to our enum
 */
export enum AuthChallengeName {
    NONE = 'NONE',
    NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
    MFA_SETUP = 'MFA_SETUP',
    SELECT_MFA_TYPE = 'SELECT_MFA_TYPE',
    MFA_REQUIRED = 'MFA_REQUIRED',
    SMS_MFA = 'SMS_MFA',
    TOTP_REQUIRED = 'TOTP_REQUIRED',
    SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
    CUSTOM_CHALLENGE = 'CUSTOM_CHALLENGE',
}